export default {"src":"/gallery/_next/static/media/wallet-connect.e55fc57f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};